<app-modal class="tool-reset-modal">
    <ng-container modal-header>
        <h5 class="modal-title">
            {{ 'admin.tools.details.reset-confirmation-modal.title' | translate:{toolName: selectedTool?.name} }}
        </h5>
    </ng-container>
    <div class="body" modal-body>
        <app-tool-reset-form
            [isScanListenerActive]="isScanListenerActive"
            [scannedTools]="scannedTools"
            (toolWasScanned)="toolWasScanned($event)"
            (rowAlertClicked)="rowAlertClicked($event)"
            (resetFormStatus)=onResetFormStatus($event)>
        </app-tool-reset-form>
    </div>
    <div class="footer" modal-footer>
        <app-button type="simple"
                    (click)="close()">{{ 'generic.buttons.close' | translate }}
        </app-button>
        <app-button type="primary"
                    (click)="onResetTool()"
                    [disabled]="!isResetFormValid || selectedTool?.issue || loading">
            {{ 'generic.buttons.reset'| translate }}
        </app-button>
    </div>
</app-modal>


